import ROUTES from '@/config/ROUTES.js'
import {createRouter, createWebHistory} from 'vue-router'

const routes = [
    {
        path: '/se-connecter',
        name: ROUTES.AUTH.LOGIN,
        component: () => import('@/views/Auth/AuthLogin.vue')
    },
    {
        name: ROUTES.AUTH.BASE,
        component: () => import('@/views/Auth/Auth.vue'),
        children: [
            {
                path: '/actualites',
                name: ROUTES.ACTUALITY.INDEX,
                component: () => import('@/views/Actuality/ActualityIndex.vue')
            },
            {
                path: '/actualites/:id',
                name: ROUTES.ACTUALITY.SHOW,
                component: () => import('@/views/Actuality/ActualityShow.vue')
            },
            {
                path: '/evenements',
                name: ROUTES.EVENT.INDEX,
                component: () => import('@/views/Event/EventIndex.vue')
            },
            {
                path: '/categories',
                name: ROUTES.DOCUMENT.CATEGORY.INDEX,
                component: () => import('@/views/Document/DocumentCategoryIndex.vue'),
                children: [
                    {
                        path: ':categoryId/subcategories',
                        name: ROUTES.DOCUMENT.CATEGORY.SHOW,
                        component: () => import('@/views/Document/DocumentCategoryShow.vue'),
                        children: [
                            {
                                path: ':subCategoryId',
                                name: ROUTES.DOCUMENT.SUB_CATEGORY.SHOW,
                                component: () => import('@/views/Document/DocumentSubCategoryShow.vue')
                            },
                        ]
                    }
                ]
            },
            {
                path: '/babillard',
                name: ROUTES.NOTICE.INDEX,
                component: () => import('@/views/Notice/NoticeIndex.vue')
            },
            {
                path: '/babillard/:id',
                name: ROUTES.NOTICE.SHOW,
                component: () => import('@/views/Notice/NoticeShow.vue')
            },
        ]
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'catch-all',
        component: () => import('@/views/NotFound.vue')
    }
]

export default createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    linkActiveClass: '-active',
    linkExactActiveClass: '-exact-active',
    routes: routes,
    scrollBehavior(to, from) {
        document.activeElement.blur()

        if (to.hash) {
            return {el: to.hash, behavior: 'smooth', top: 100}
        }

        if (to.path !== from.path) {
            document.activeElement.blur()
            return {top: 0, behavior: 'smooth'}
        }

        if (to.query !== from.query) {
            return false
        }

        return {left: 0, top: 0}
    }
})